exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/*!\n *  Font Awesome 4.5.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(" + require("../fonts/fontawesome-webfont.eot") + ");src:url(" + require("../fonts/fontawesome-webfont.eot") + "?#iefix) format('embedded-opentype'),url(" + require("../fonts/fontawesome-webfont.woff2") + ") format('woff2'),url(" + require("../fonts/fontawesome-webfont.woff") + ") format('woff'),url(" + require("../fonts/fontawesome-webfont.ttf") + ") format('truetype'),url(" + require("../fonts/fontawesome-webfont.svg") + "?#fontawesomeregular) format('svg');font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-pencil:before{content:\"\\F040\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./vendor/css/font-awesome.css
 ** module id = 410
 ** module chunks = 0
 **/